import React, { FC } from 'react';

import { EnrollmentPaymentType } from '../../model/EnrollmentPaymentTypes';
import { CreditCardEditor } from '../credit-card/CreditCardEditor';
import { SepaEditor } from '../Sepa/SepaEditor';
import { PayPalEditor } from '../paypal/PayPalEditor';
import { CashOnDeliveryOption } from '../cash-on-delivery/CashOnDeliveryOption';
import { WireTransferEditor } from '../wire-transfer/WireTransferEditor';

interface PaymentMethodEditorProps {
  method: EnrollmentPaymentType;
}

export const PaymentMethodEditor: FC<PaymentMethodEditorProps> = ({ method }) => {
  switch (method) {
    case EnrollmentPaymentType.CreditCard:
      return <CreditCardEditor />;
    case EnrollmentPaymentType.Sepa:
      return <SepaEditor />;
    case EnrollmentPaymentType.PayPal:
      return <PayPalEditor />;
    case EnrollmentPaymentType.Cod:
      return <CashOnDeliveryOption />
    case EnrollmentPaymentType.WireTransfer:
      return <WireTransferEditor />;
    default:
      return null;
  }
};
